"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./styles/MultiInput.scss");
/**
 * A higher order component that renders children as a single input to the user.
 * This handles:
 *   Automatic focus of children
 *   Handling backspace keystroke
 *   Automatic focus to first empty input
 *   Left and right, home and end keystrokes
 */
function MultiInput(_a) {
    var _this = this;
    var config = _a.config, children = _a.children;
    var handleKeyDown = function (event) {
        var previousSibling = event.target.previousSibling;
        if (event.keyCode === 8 &&
            event.target.value.length === 0 &&
            previousSibling &&
            !previousSibling.value) {
            previousSibling.focus();
        }
        // TODO: could also handle left, right, home and end keys
    };
    var handleOnFocus = function (event) {
        if (config.inputAnyOrder) {
            return;
        }
        var previous = event.target.previousSibling;
        if (previous && (previous.value === '' || previous.value === undefined)) {
            // Need to call focus in another turn of the event loop, otherwise it may be called twice,
            // this is problematic...
            setTimeout(function () { return previous.focus(); }, 1);
        }
    };
    var renderChild = function (child, i) {
        var change = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var event = args[0];
            var _a = event.target, name = _a.name, value = _a.value;
            var _b = config.validityConfig.get(name), validRegex = _b.validRegex, length = _b.length;
            if (!validRegex.test(value) && value !== '') {
                return;
            }
            if (value.length === length) {
                var next = event.target.nextSibling;
                if (next) {
                    next.focus();
                }
            }
            else if (value.length === 0) {
                var previous = event.target.previousSibling;
                if (previous) {
                    if (!previous.value) {
                        previous.focus();
                    }
                }
            }
            if (child.props && child.props.onChange) {
                return child.props.onChange.apply(_this, args);
            }
        };
        return React.cloneElement(child, {
            onKeyDown: handleKeyDown,
            onFocus: handleOnFocus,
            onChange: change,
            key: i
        });
    };
    var wrapperClass = 'multi-input-group';
    return (React.createElement("div", { className: wrapperClass }, children.map(renderChild)));
}
exports.default = MultiInput;
